import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { colors } from '../../theme'

export const TopStyle = styled.div<{ isBigMenu: boolean }>`
  display: flex;
  justify-content: space-between;
  width: ${({ isBigMenu }) =>
    isBigMenu ? 'calc(100% - 200px)' : 'calc(100% - 100px)'};
  position: fixed;
  right: 0;
  padding: 15px 0;
  background-color: ${colors.surface};
  z-index: 1;
`

export const UserIconStyle = styled.div`
  background-color: ${colors.surfaceHigh};
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
`

export const UserLog = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  margin-right: 35px;
`

export const TopUserDataStyles = styled.div`
  p {
    font-size: 14px;
    color: ${colors.grey900};
  }
  .email {
    font-size: 12px;
    font-weight: 600;
    color: ${colors.grey600};
  }
`

export const IconDown = styled.button`
  margin-left: 20px;
  background-color: ${colors.surface};
  border: none;
  cursor: pointer;
`
export const ConfigButtons = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 7px 20px ${colors.azulOpaco};
  width: auto;
  min-height: 100px;
  justify-content: center;
  gap: 8px;
  border-radius: 24px;
  position: absolute;
  top: 70px;
  right: 23px;
  background-color: ${colors.surface};
  z-index: 2;
  padding: 15px;
`
export const Span = styled.span`
  display: flex;
  align-items: center;
  font-size: 12px;
  margin: 10px 10px 0px 10px;
  padding-bottom: 10px;
  color: ${colors.grey600};
  background-color: ${colors.surface};
  border-bottom: 0.5px solid ${colors.grey200};
`

export const SpanLogout = styled(Link)`
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 5px 0;
  text-decoration: none;
  color: ${colors.grey600};
  margin: 0px 10px 0px 10px;
`

export const SpanText = styled(Link)`
  margin-left: 10px;
  text-decoration: none;
  color: ${colors.grey900} !important;

  p {
    font-size: 14px;
    font-weight: 600;
  }
`
export const Button = styled.button`
  margin-left: 30px;
  background-color: ${colors.surface};
  border: none;
  cursor: pointer;
`
